// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + ({"443":"about","508":"browserHistory","826":"index","844":"noFound","910":"myPaper"}[chunkId] || chunkId) + "." + {"201":"a8c17547","443":"bc0a1e5a","508":"5ff07dfc","770":"557524eb","826":"98473c50","844":"11fe9f52","910":"ed3bcdbc"}[chunkId] + ".css";
};